
export class UpdateContext {

    constructor(timeStamp: number, secondsPassed: number) {
        this.timeStamp = timeStamp;
        this.secondsPassed = secondsPassed;
    }

    public readonly timeStamp: number = 0;
    public readonly secondsPassed: number = 0;
}

export interface IUpdateable {
    update(context: UpdateContext) : void;
}